export const DatasetSourceName: Record<string, string> = {
  Npi: 'NPPES NPI Registry',
  Dea: 'DEA Diversion Control Division',
  Sam: 'System for Award Management',
  MedicareOptOut: 'National Medicare Opt-Out Database',
  OigFugitives: 'Office of Inspector General - Most Wanted Fugitives',
  OfacSdn: 'Office of Foreign Assets Control - Specially Designated Nationals',
  OfacConsolidated: 'Office of Foreign Assets Control - Non-Specially Designated Nationals',
  OigExclusions: 'Office of Inspector General - List of Excluded Individuals/Entities',
  StateSanctionsAndExclusions: 'State Medicaid Exclusion Lists',
  Dmf: `Social Security Administration's Death Master File`,
  CmsPreclusion: 'Centers for Medicare & Medicaid Services Preclusion List',
  Npdb: 'National Practitioner Data Bank',
  Tricare: 'TRICARE provider exclusion database',
  FacilityCmsCertification: 'Centers for Medicare & Medicaid Services'
};
